export default __webpack_public_path__ + "static/media/vox-img-legacy-011.bf4b51fd.jpg";